module.exports = __webpack_public_path__ + "static/media/stats-registration.dcae3bb3.png";